import {
  Flex,
  Container,
  Box,
  Text,
  IntrinsicImage,
  Link,
} from '@tishman/components';
import React from 'react';

import { formatStoryCategory } from '../utils';

import { BorderedBox } from './BorderedBox';

interface AtlasLargeFeatureProps {
  data: any;
  featured?: boolean;
}

const AtlasLargeFeature = (props: AtlasLargeFeatureProps): JSX.Element => {
  const { title, alt, formattedPublishAt, url, image, excerpt, category } =
    props.data;

  const formattedCategory = formatStoryCategory(category);

  return (
    <Container
      sx={{
        pt: [6, null, null, 0],
        pb: 6,
        px: [null, 0],
      }}
    >
      <Flex
        sx={{
          justifyContent: 'space-between',
          alignItems: 'center',
          flexDirection: ['column', null, 'row-reverse'],
        }}
      >
        <Box
          sx={{
            display: ['block', null, 'none'],
          }}
        >
          <Flex
            sx={{
              justifyContent: 'space-between',
              alignItems: 'center',
              width: '100%',
            }}
          >
            <Text
              onClick={() =>
                props.featured && props.featured === true
                  ? (location.href = url)
                  : (location.href = `/magazine/#${formattedCategory}`)
              }
              sx={{ cursor: 'pointer' }}
              variant="featuredStoryEyebrow"
            >
              {props.featured && props.featured === true
                ? 'Featured Story'
                : category}
            </Text>
            <Text
              sx={{
                marginTop: 0,
                marginBottom: [2, null, null, 3],
              }}
              variant="storyDate"
            >
              {formattedPublishAt}
            </Text>
          </Flex>
          <Text
            as="h2"
            onClick={() => (location.href = url)}
            sx={{
              'variant': 'text.heroTitleSmall',
              'fontFamily': 'headingSecondary',
              'textAlign': 'left',
              'cursor': 'pointer',
              '&:hover': {
                color: 'CREAM',
                textDecoration: 'underline',
                textDecorationThickness: '3px',
                textUnderlineOffset: '4px',
                textDecorationSkipInk: 'none',
              },
            }}
          >
            {title}
          </Text>
        </Box>
        <BorderedBox
          sx={{
            'alignSelf': 'flex-start',
            'my': [4, null, null, null, 0],
            'mb': [0, null],
            'ml': [0, null, 5],
            'overflow': 'hidden',
            'cursor': 'pointer',
            '&:hover img': {
              transform: 'scale(1.05)',
            },
          }}
        >
          <IntrinsicImage
            alt={alt}
            image={image}
            onClick={() => (location.href = url)}
            ratio={410 / 450}
            sx={{
              transition: '0.5s ease all',
            }}
          />
        </BorderedBox>
        <Box
          sx={{
            flex: ['1 1 auto', null, '1 1 22%'],
            textAlign: ['center', null, 'left'],
            mt: 4,
            pr: ['initial', null, 4],
          }}
        >
          <Flex sx={{ display: ['none', null, 'block'] }}>
            <Flex
              sx={{
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '100%',
              }}
            >
              <Text
                onClick={() =>
                  props.featured && props.featured === true
                    ? (location.href = url)
                    : (location.href = `/magazine/#${formattedCategory}`)
                }
                sx={{ cursor: 'pointer' }}
                variant="featuredStoryEyebrow"
              >
                {props.featured && props.featured === true
                  ? 'Featured Story'
                  : category}
              </Text>
              <Text
                sx={{
                  marginTop: 0,
                  marginBottom: [2, null, null, 3],
                }}
                variant="storyDate"
              >
                {formattedPublishAt}
              </Text>
            </Flex>
            <Text
              as="h2"
              onClick={() => (location.href = url)}
              sx={{
                'variant': 'text.heroTitleSmall',
                'fontFamily': 'headingSecondary',
                'textAlign': 'left',
                'cursor': 'pointer',
                '&:hover': {
                  color: 'CREAM',
                  textDecoration: 'underline',
                  textDecorationThickness: '3px',
                  textUnderlineOffset: '4px',
                  textDecorationSkipInk: 'none',
                },
              }}
            >
              {title}
            </Text>
            <Text
              mb={[3, null, null, 4]}
              mt={[null, null, 3]}
              sx={{
                color: 'heroBackground',
              }}
            >
              {excerpt}
            </Text>
            <Link href={url} variant="storyUnderline">
              Read Story
            </Link>
          </Flex>
        </Box>
        <Box
          sx={{
            display: ['block', null, 'none'],
          }}
        >
          <Text
            mb={[3, null, null, 4]}
            sx={{
              color: 'heroBackground',
            }}
          >
            {excerpt}
          </Text>
          <Link href={url} variant="storyUnderline">
            Read Story
          </Link>
        </Box>
      </Flex>
    </Container>
  );
};

export default AtlasLargeFeature;
